// extracted by mini-css-extract-plugin
module.exports = {"note-card":"noteCard_note-card__1j-7r","card-body":"noteCard_card-body__3t_Kw","card-footer":"noteCard_card-footer__gyx3B"};